import http from '~/common/http'
export default {
    getList(params, action) {
        return http.get('/api/sales-leads-count/' + action, {
            params: params
        });
    },
    getUserData(params) {
        return http.get('/api/sales-leads-count/user-data', {
            params: params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/ClueCount.js